import { HTMLAttributes, ReactNode } from 'react';
import { FieldProps } from 'formik';

import * as S from '../DateField/styles';
import theme from 'styles/theme';

export interface MaskFieldProps extends HTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  name?: string;
  icon?: JSX.Element;
  isValid?: boolean;
  feedbackMessage?: ReactNode;
  mask: string;
  type?: string;
}

const MaskField = ({
  label,
  required = false,
  isValid = true,
  feedbackMessage,
  icon,
  name,
  placeholder,
  mask,
  type,
  ...props
}: MaskFieldProps) => {
  return (
    <div>
      {label && (
        <S.Label htmlFor={name} aria-required={required} required={required}>
          {label}
        </S.Label>
      )}
      <S.Container>
        <S.Field
          icon={isValid}
          isValid={isValid}
          name={name}
          type={type}
          {...props}
        >
          {({ field }: FieldProps) => (
            <S.Mask
              {...field}
              isValid={isValid}
              mask={mask}
              placeholder={placeholder}
              inputMode="numeric"
              maskChar=""
            />
          )}
        </S.Field>
        {icon && <S.IconContainer>{icon}</S.IconContainer>}
      </S.Container>
      {feedbackMessage && (
        <S.FeedbackMessage
          color={
            !isValid
              ? theme.colors.statusDanger50
              : theme.colors.statusSuccess50
          }
        >
          {feedbackMessage}
        </S.FeedbackMessage>
      )}
    </div>
  );
};

export default MaskField;
